import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountRoutingModule } from './account.routing.module';
import { AccountComponent } from './account.component';
import { SharedModule } from '../shared/shared.module';
import { ProfileComponent } from './profile/profile.component';
import { MaterialModule } from '../shared/material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
@NgModule({
	imports: [
		CommonModule,
		AccountRoutingModule,
		SharedModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatPasswordStrengthModule,
	],
	declarations: [ChangePasswordComponent, AccountComponent, ProfileComponent],
})
export class AccountModule {}
